<template>
  <div class="styled-dropdown">
    <select>
      <option data-placeholder>
        Sort
      </option>
      <option
        v-for="option in options"
        :key="option.label"
        :value="option.value"
        :selected="sort === option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import easydropdown from 'easydropdown'

export default {
  name: 'ResultsSort',

  data () {
    return {
      options: [
        {
          label: 'Most Popular',
          value: 'popular-desc'
        },
        {
          label: 'Name (A-Z)',
          value: 'name-asc'
        },
        {
          label: 'Name (Z-A)',
          value: 'name-desc'
        },
        {
          label: 'Price (Low - High)',
          value: 'price-asc'
        },
        {
          label: 'Price (High - Low)',
          value: 'price-desc'
        }
      ]
    }
  },

  computed: {
    ...mapState([
      'sort'
    ])
  },

  mounted () {
    easydropdown(this.$el.querySelector('select'), {
      callbacks: {
        onSelect: () => this.setSort(this.$el.querySelector('select').value)
      }
    })
  },

  methods: {
    ...mapMutations([
      'setSort'
    ])
  },
}
</script>
